import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '@modules/constants-enumerate';
import {deepAssign} from '@aofl/object-utils';
import {dashboardLabels} from '@modules/i18n-labels';

const sdo = {
  namespace: sdoNs.PROGRESS_FILTERS_VIEW,
  mutations: {
    init() {
      return {
        filters: {
          nameFilter: '',
          statusFilter: '',
          gradeFilter: '',
          standardSetFilter: '',
          standardCategoryFilter: '',
          activeThisWeekFilter: false,
        },
        clickedFilters: {
          nameFilter: false,
          statusFilter: false,
          gradeFilter: false,
          standardSetFilter: false,
          standardCategoryFilter: false,
          activeThisWeekFilter: false,
        },
        skillsLoaded: false,
        skillInfo: [],
        grades: [],
        externalStandardSets: [],
        loParents: [],
        loParentsCategory: '',
        skillCountsPerGrade: {}
      };
    },
    resetFiltersExceptSet(subState) {
      return {
        ...subState,
        filters: {
          ...subState.filters,
          nameFilter: '',
          statusFilter: '',
          gradeFilter: '',
          standardCategoryFilter: '',
          activeThisWeekFilter: false
        }
      };
    },
    setData(subState, payload) {
      return {
        ...subState,
        data: {
          node_codes: payload.node_codes,
          external_standards: payload.external_standards
        }
      };
    },
    setGrades(subState, gradesBuckets) {
      const grades = gradesBuckets.map((item) => item.key);
      return {
        ...subState,
        grades
      };
    },
    setGradeFilter(subState, payload) {
      const filters = {
        ...subState.filters,
      };
      filters.gradeFilter = payload;
      filters.standardCategoryFilter = '';
      const nextState = {
        ...subState,
        filters,
        clickedFilters: {
          ...subState.clickedFilters,
          gradeFilter: true,
          standardCategoryFilter: false,
        }
      };
      return nextState;
    },
    setStandardSetFilter(subState, payload) {
      return {
        ...subState,
        filters: {
          ...subState.filters,
          standardSetFilter: payload,
          gradeFilter: '',
          standardCategoryFilter: '',
        },
        clickedFilters: {
          ...subState.clickedFilters,
          standardSetFilter: true,
          gradeFilter: false,
          standardCategoryFilter: false,
        }
      };
    },
    setStandardCategoryFilter(subState, payload) {
      return {
        ...subState,
        filters: {
          ...subState.filters,
          standardCategoryFilter: payload,
        },
        clickedFilters: {
          ...subState.clickedFilters,
          standardCategoryFilter: true,
        }
      };
    },
    setNameFilter(subState, payload) {
      return {
        ...subState,
        filters: {
          ...subState.filters,
          nameFilter: payload
        },
        clickedFilters: {
          ...subState.clickedFilters,
          nameFilter: true,
        }
      };
    },
    setStatusFilter(subState, payload) {
      return {
        ...subState,
        filters: {
          ...subState.filters,
          statusFilter: payload
        },
        clickedFilters: {
          ...subState.clickedFilters,
          statusFilter: true
        }
      };
    },
    setSkillCountsPerGrade(subState, payload) {
      const skillCountsPerGrade = {};
      let grades = [];
      const coreGrades = [
        'Pre-K',
        'Kindergarten',
        '1st Grade',
        '2nd Grade'
      ];
      payload.map((item) => {
        skillCountsPerGrade[item.key] = item.doc_count;
        if (coreGrades.includes(item.key)) {
          grades.push(item.key);
        }
      });
      // To sort grades
      grades = coreGrades.filter(value => grades.includes(value));
      return {
        ...subState,
        grades,
        skillCountsPerGrade,
      };
    },
    setActiveThisWeekFilter(subState, payload) {
      return {
        ...subState,
        filters: {
          ...subState.filters,
          activeThisWeekFilter: payload
        },
        clickedFilters: {
          ...subState.clickedFilters,
          activeThisWeekFilter: true,
        }
      };
    },
    resetFilters(subState) {
      return {
        ...subState,
        filters: {
          nameFilter: '',
          statusFilter: '',
          standardSetFilter: '',
          gradeFilter: '',
          standardCategoryFilter: '',
          activeThisWeekFilter: false
        },
        clickedFilters: {
          nameFilter: false,
          statusFilter: false,
          gradeFilter: false,
          standardSetFilter: false,
          standardCategoryFilter: false,
          activeThisWeekFilter: false,
        }
      };
    }
  },
  decorators: [
    (nextState) => { // $hasFilter
      const state = storeInstance.getState();
      const progressFiltersState = state[sdoNs.PROGRESS_FILTERS_VIEW];
      const progressFiltersNextState = nextState[sdoNs.PROGRESS_FILTERS_VIEW];
      let $hasFilter = false;

      if (progressFiltersNextState.filters !== progressFiltersState.filters) {
        // Check if any are not empty
        if (progressFiltersNextState.filters.nameFilter ||
          progressFiltersNextState.filters.statusFilter ||
          progressFiltersNextState.filters.gradeFilter ||
          progressFiltersNextState.filters.standardSetFilter ||
          progressFiltersNextState.filters.standardCategoryFilter ||
          progressFiltersNextState.filters.activeThisWeekFilter) {
          $hasFilter = true;
        }

        nextState = deepAssign(nextState, sdoNs.PROGRESS_FILTERS_VIEW, {
          $hasFilter,
        });
      }
      return nextState;
    },
    (nextState) => { // $standardSets
      const state = storeInstance.getState();
      const subState = state[sdoNs.PROGRESS_FILTERS_VIEW];
      const nextSubState = nextState[sdoNs.PROGRESS_FILTERS_VIEW];
      const $standardSets = [];

      if (
        typeof nextSubState.$standardSets === 'undefined' ||
        nextSubState.externalStandardSets !== subState.externalStandardSets
      ) {
        if (
          nextSubState.externalStandardSets &&
          Object.values(nextSubState.externalStandardSets).length > 0
        ) {
          for (const [id, standard] of Object.entries(nextSubState.externalStandardSets)) {
            $standardSets.push({
              value: standard.id,
              label: standard.properties.name
            });
          }
        }
        nextState = deepAssign(nextState, sdoNs.PROGRESS_FILTERS_VIEW, {
          $standardSets,
        });
      }
      return nextState;
    },
    (nextState) => { // $selectedStandardSet
      const state = storeInstance.getState();
      const subState = state[sdoNs.PROGRESS_FILTERS_VIEW];
      const nextSubState = nextState[sdoNs.PROGRESS_FILTERS_VIEW];
      let $selectedStandardSet = {};

      if (
        typeof nextSubState.$selectedStandardSet === 'undefined' ||
        nextSubState.$standardSets !== subState.$standardSets ||
        nextSubState.filters.standardSetFilter !== subState.filters.standardSetFilter
      ) {
        nextSubState.$standardSets.map((standardSet) => {
          if (standardSet.value === nextSubState.filters.standardSetFilter) {
            $selectedStandardSet = {
              ...standardSet
            };
          }
        });
        nextState = deepAssign(nextState, sdoNs.PROGRESS_FILTERS_VIEW, {
          $selectedStandardSet,
        });
      }
      return nextState;
    },
    (nextState) => { // $filtersForBI
      const state = storeInstance.getState();
      const subState = state[sdoNs.PROGRESS_FILTERS_VIEW];
      const nextSubState = nextState[sdoNs.PROGRESS_FILTERS_VIEW];
      const $filtersForBI = [];

      if (typeof nextSubState.$filtersForBI === 'undefined' || subState.clickedFilters !== nextSubState.clickedFilters) {
        for (const [key, clicked] of Object.entries(nextSubState.clickedFilters)) {
          if (clicked) {
            let filterValue = nextSubState.filters[key];
            if (filterValue === '') {
              filterValue = 'all';
            }
            $filtersForBI.push({key, value: filterValue});
          }
        }
        nextState = deepAssign(nextState, sdoNs.PROGRESS_FILTERS_VIEW, {
          $filtersForBI
        });
      }
      return nextState;
    },
    (nextState) => { // $loParentsSelectedCategory
      const state = storeInstance.getState();
      const subState = state[sdoNs.PROGRESS_FILTERS_VIEW];
      const nextSubState = nextState[sdoNs.PROGRESS_FILTERS_VIEW];
      let $loParentsSelectedCategory = '';

      if (
        typeof nextSubState.$selectedStandardSet === 'undefined' ||
        nextSubState.filters.grade !== subState.filters.grade ||
        nextSubState.filters.standardCategoryFilter !== subState.filters.standardCategoryFilter ||
        nextSubState.loParentsCategory !== subState.loParentsCategory
      ) {

        if (nextSubState.filters.standardCategoryFilter === '') {
          $loParentsSelectedCategory = dashboardLabels.selectCategory(nextSubState.loParentsCategory);
        } else {
          $loParentsSelectedCategory = nextSubState.filters.standardCategoryFilter;
        }
        nextState = deepAssign(nextState, sdoNs.PROGRESS_FILTERS_VIEW, {
          $loParentsSelectedCategory,
        });
      }
      return nextState;
    },
  ]
};

storeInstance.addState(sdo);
